import React, { useState } from "react";
import Header from "./components/Header/Header";
import Cart from "./components/Cart/Cart";
import Admin from "./components/Admin/Admin";
import AdminLogin from "./components/Admin/AdminLogin";
import MainContent from "./components/MainContent/MainContent";
import ProductsList from "./components/ProductsList/ProductsList";
import Login from "./components/Login/Login";
import "./App.css";

function App() {
  const [currentView, setCurrentView] = useState("home");
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false); // Login modal state
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  const handleAddToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    setIsCartOpen(true);
  };

  const handleCartClick = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);

  const openLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);

  const handleUserLogin = (userData) => {
    console.log("Logged in user:", userData);
    setIsAdminLoggedIn(true); // Optional: set admin login after modal
    closeLogin();
    setCurrentView("admin"); // Optional: switch to admin panel after login
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case "admin":
        return isAdminLoggedIn ? (
          <Admin />
        ) : (
          <AdminLogin onLogin={() => setIsAdminLoggedIn(true)} />
        );
      case "home":
      default:
        return (
          <>
            <MainContent />
            <ProductsList onAddToCart={handleAddToCart} />
          </>
        );
    }
  };

  return (
    <>
      <nav className="app-navigation">
        <button
          className={currentView === "home" ? "active" : ""}
          onClick={() => setCurrentView("home")}
        >
          Home
        </button>
        <button
          className={currentView === "admin" ? "active" : ""}
          onClick={() => setCurrentView("admin")}
        >
          Admin Panel
        </button>
      </nav>

      <Header
        onCartClick={handleCartClick}
        onLoginClick={openLogin} // Login button opens modal
        cartCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)}
      />

      {renderCurrentView()}

      <Cart
        isOpen={isCartOpen}
        onClose={closeCart}
        cartItems={cartItems}
        setCartItems={setCartItems}
      />

      <Login
        isOpen={isLoginOpen}
        onClose={closeLogin}
        onLogin={handleUserLogin}
      />
    </>
  );
}

export default App;
